import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "rows", "placeholder", "value", "disabled", "required"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("textarea", {
    id: $props.id,
    rows: $props.rows,
    placeholder: $props.placeholder,
    value: $props.modelValue,
    disabled: $props.disabled,
    required: $props.required,
    class: _normalizeClass(['block w-full resize-y scrollbar-hidden bg-white dark:bg-gray-700 rounded-lg border border-slate-300 dark:border-gray-600 p-2 focus:outline-none disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:text-slate-800 dark:disabled:text-slate-300 text-slate-800 dark:text-slate-100', $props.className]),
    style: {
      "background-color": "white",
      "color": "black"
    },
    onInput: _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event.target.value))
  }, null, 42, _hoisted_1);
}